import * as React from "react"
import { ArrowDownRight, ArrowUpRight } from "lucide-react"
import { cn } from "../lib/utils"
import { Card } from "./Card"

interface StatCardProps {
  label: string
  value: React.ReactNode
  icon?: React.ReactNode
  /** Percentage / delta string, e.g. "+12.5%". */
  delta?: string
  trend?: "up" | "down" | "neutral"
  /** Helper line under the value, e.g. "vs. last month". */
  hint?: string
  className?: string
  onClick?: () => void
}

const trendStyles: Record<string, string> = {
  up: "text-success bg-success/10",
  down: "text-destructive bg-destructive/10",
  neutral: "text-muted-foreground bg-muted",
}

export function StatCard({
  label,
  value,
  icon,
  delta,
  trend = "neutral",
  hint,
  className,
  onClick,
}: StatCardProps) {
  return (
    <Card
      interactive={!!onClick}
      onClick={onClick}
      className={cn("p-6", className)}
    >
      <div className="flex items-start justify-between gap-3">
          <span className="text-label text-text-tertiary">
          {label}
        </span>
        {icon && (
           <span className="flex size-10 items-center justify-center rounded-[10px] bg-accent text-primary [&_svg]:size-5">
            {icon}
          </span>
        )}
      </div>
      <div className="mt-3 flex items-end justify-between gap-2">
        <span className="font-display text-metric text-foreground tabular-nums">
          {value}
        </span>
        {delta && (
          <span
            className={cn(
              "inline-flex items-center gap-0.5 rounded-full px-2 py-0.5 text-label font-semibold",
              trendStyles[trend]
            )}
          >
            {trend === "up" && <ArrowUpRight className="size-3.5" />}
            {trend === "down" && <ArrowDownRight className="size-3.5" />}
            {delta}
          </span>
        )}
      </div>
      {hint && <p className="mt-2 text-caption text-text-tertiary">{hint}</p>}
    </Card>
  )
}
